// The statuses that let an officer into the app. Must match
// isEntitledStatus() in server/src/services/subscriptionAccess.ts, which is
// what the API enforces (402 subscription_required).
export const isEntitledStatus = (status: string | null | undefined) =>
  status === "active" || status === "trialing";
